import { render, staticRenderFns } from "./TPLinkRouter.vue?vue&type=template&id=5f8e561b&scoped=true&"
import script from "./TPLinkRouter.vue?vue&type=script&lang=js&"
export * from "./TPLinkRouter.vue?vue&type=script&lang=js&"
import style0 from "./TPLinkRouter.vue?vue&type=style&index=0&id=5f8e561b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e561b",
  null
  
)

export default component.exports